export const COMMENT_INPUT_HEIGHT = 46;
